/** @format */

import React from "react";
import Table from "./DetailsTable";
import Order from "./OrderDetails";
import Button from "@mui/material/Button";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFdocumentOrder from "../pdf_&_excel/PDFexportOrders";
import PDFdocumentInvoice from "../pdf_&_excel/PDFexportInvoices";
import ExcelExportOrders from "../pdf_&_excel/ExcelExportOrders";
import ExcelExportInvoices from "../pdf_&_excel/ExcelExportInvoices";
import { SideDetailsAnimateContext } from "../contexts/SideDetailsAnimateContext";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { SideDetailsContext } from "../contexts/SideDetailsContext";
import { useLocation } from "react-router-dom";

const theme = createTheme({
	palette: {
		custom: {
			light: "#FFFFFF",
			main: "#FFFFFF",
			dark: "#000000",
			contrastText: "rgba(0, 0, 0, 0.88)",
		},
	},
});

const SideDetails = React.memo((title) => {
	const animateSideDetailsOut = React.useContext(SideDetailsAnimateContext);
	const { contextValue } = React.useContext(SideDetailsContext);
	const { order } = contextValue;

	const pdfFileName = () => {
		const date = new Date(contextValue.dateTimeStamp).toLocaleDateString("sr").slice(0, -1);
		const fileName = `${contextValue.buyer} - ${date} - ${contextValue.id}.pdf`;
		return fileName;
	};

	const titleRef = React.useRef(""); // Create a mutable ref for title
	const numberRef = React.useRef("");
	const dateRef = React.useRef("");
	const valueRef = React.useRef("");

	const sideProps = {
		title: {
			"/": "Detalji porudžbine",
			"/invoices": "Detalji fakture",
		},
		number: {
			"/": "Porudžbina br:",
			"/invoices": "Faktura br:",
		},
		date: {
			"/": "Datum porudžbine:",
			"/invoices": "Datum fakture:",
		},
		value: {
			"/": "Ukupna vrednost porudžbine:",
			"/invoices": "Ukupan iznos fakture:",
		},
	};

	const location = useLocation();

	React.useEffect(() => {
		titleRef.current = sideProps.title[location.pathname];
		animateSideDetailsOut();
		numberRef.current = sideProps.number[location.pathname];
		dateRef.current = sideProps.date[location.pathname];
		valueRef.current = sideProps.value[location.pathname];
	}, [
		animateSideDetailsOut,
		location,
		sideProps.date,
		sideProps.number,
		sideProps.title,
		sideProps.value,
	]);

	return (
		<>
			<div className="sd-header sd-common">
				<h2>{titleRef.current}</h2>
				<ThemeProvider theme={theme}>
					<Button
						variant="outlined"
						onClick={animateSideDetailsOut}
						color="custom"
					>
						Izlazak iz detalja
					</Button>
				</ThemeProvider>
			</div>
			{/* these are names for the fields, not values */}
			<Order
				number={numberRef}
				date={dateRef}
				value={valueRef}
			/>
			<div className="sd-products sd-height sd-common">
				<div className="pdf-exl-wrap">
					<h3>Pregled po artiklima</h3>
					<div className="pdf-exl-buttons-wrap">
						<PDFDownloadLink
							document={
								location.pathname === "/invoices" ? (
									<PDFdocumentInvoice data={order} />
								) : (
									<PDFdocumentOrder order={order} />
								)
							}
							fileName={pdfFileName()}
						>
							{({ loading }) =>
								loading ? (
									"Spremam pdf fajl..."
								) : (
									<Button
										className="pdf-btn"
										variant="contained"
									>
										.pdf
									</Button>
								)
							}
						</PDFDownloadLink>
						{location.pathname === "/invoices" ? <ExcelExportInvoices /> : <ExcelExportOrders />}
					</div>
				</div>
				<Table order={order} />
			</div>
		</>
	);
});

export default SideDetails;
